import { css } from '@emotion/react';
import * as React from 'react';

import { useGlobalState } from '~src/global-state';

import { Spinner } from './botox-spinner';

export const UpdateLoader: React.FC = () => {
  const globalState = useGlobalState();
  // TODO: move the config to global state.
  const session = globalState.sessions[0];

  const { enable_widget_border } = session.flags;

  return (
    <div css={styles.wrapper(!!enable_widget_border)} data-test="loader">
      <Spinner />
    </div>
  );
};

const styles = {
  wrapper: (enableWidgetBorder: boolean) =>
    css({
      opacity: '0.9',
      position: 'fixed',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'white',
      zIndex: 100,
      borderRadius: enableWidgetBorder ? '6px' : '0',
      // Account for borders on the widget
      top: enableWidgetBorder ? '1px' : '0',
      bottom: enableWidgetBorder ? '1px' : '0',
      left: enableWidgetBorder ? '1px' : '0',
      right: enableWidgetBorder ? '1px' : '0',
    }),
};
